import { useRef, useState } from "react";
import emailjs from "@emailjs/browser";

export default function Contact() {
  const formRef = useRef();
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState("");

  const sendEmail = (e) => {
    e.preventDefault();
    setLoading(true);

    console.log(process.env.REACT_APP_EMAILJS_PUBLIC_KEY);
    // Admin email
    emailjs
      .sendForm(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_ADMIN_TEMPLATE_ID,
        formRef.current,
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY
      )
      .then(() => {
        // User confirmation email
        return emailjs.sendForm(
          process.env.REACT_APP_EMAILJS_SERVICE_ID,
          process.env.REACT_APP_EMAILJS_USER_TEMPLATE_ID,
          formRef.current,
          process.env.REACT_APP_EMAILJS_PUBLIC_KEY
        );
      })
      .then(() => {
        setStatus("success");
        formRef.current.reset();
      })
      .catch((error) => {
        console.error("EmailJS error:", error);

        // Extra details (EmailJS sometimes nests the message)
        if (error?.text) {
          console.error("EmailJS error text:", error.text);
        }

        setStatus("error");
      })
      .finally(() => setLoading(false));
  };

  return (
    <section className="contact">
      <div className="container contact-container">

        {/* Contact Form */}
        <div className="contact-form">
          <h3>Get In Touch</h3>

          <form ref={formRef} onSubmit={sendEmail}>
            <div className="form-group">
              <label>Full Name</label>
              <input name="name" type="text" required placeholder="Your Name" />
            </div>

            <div className="form-group">
              <label>Email Address</label>
              <input name="email" type="email" required placeholder="Your Email" />
            </div>

            <div className="form-group">
              <label>Message</label>
              <textarea
                name="message"
                rows="5"
                required
                placeholder="Your Message"
              ></textarea>
            </div>

            <button
              type="submit"
              className="btn btn-primary"
              style={{ width: "100%" }}
              disabled={loading}
            >
              {loading ? "Sending..." : "Send Message"}
            </button>

            {status === "success" && (
              <p style={{ color: "green", marginTop: "1rem" }}>
                ✅ Message sent successfully. We’ll contact you soon!
              </p>
            )}

            {status === "error" && (
              <p style={{ color: "red", marginTop: "1rem" }}>
                ❌ Something went wrong. Please try again later.
              </p>
            )}
          </form>
        </div>

        {/* Contact Info */}
        <div className="contact-info">
          <h3>Contact Information</h3>

          <div className="contact-detail">
            <div className="contact-icon"><i className="fas fa-map-marker-alt"></i></div>
            C2-14, UGF, KA-323, Sector-12, Pratap Vihar, Ghaziabad, UP-201009
          </div>

          <div className="contact-detail">
            <div className="contact-icon"><i className="fas fa-phone"></i></div>
            <a href="tel:+918979509737">+91 8979509737</a>
          </div>

          <div className="contact-detail">
            <div className="contact-icon"><i className="fas fa-envelope"></i></div>
            office@rvibes.in
          </div>
        </div>

      </div>
    </section>
  );
}
